import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';

import StickyVRMUlez from '../../../../../components/misc/StickyVRM/StickyVRMUlez';
import SimilarArticles from '../../../common/SimilarArticles/SimilarArticles';
import { generateSimilarArticlesData } from '../../../common/SimilarArticles/SimilarArticlesHelpers';
import Hero from '../Hero/Hero';
import InfoUlezPage from '../InfoUlezPage/InfoUlezPage';
import Map from '../Map/Map';
import Section from '../Section/Section';
import UlezFAQ from '../UlezFAQ/UlezFAQ';
import type { FAQType } from '../UlezPage.types';

import Charges from './Charges';
import Scheme from './Scheme';

import styles from './Home.scss';

type UlezHomeProps = {
  acf: Record<string, unknown>;
  faq: FAQType[];
};

const Home = ({ acf, faq }: UlezHomeProps) => {
  const {
    faq_title: title,
    header_description: headerDescription,
    header_title: headerTitle,
  } = acf;

  const [ready, setReady] = useState(false);
  const [expandedMap, setExpandedMap] = useState(false);

  const $content = useRef(null);

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <div className={cx({ [styles.colorfulWrapper]: expandedMap })}>
      <Hero
        eyebrow="ULEZ Checker"
        subTitle={headerDescription as string}
        title={headerTitle as string}
      />
      <InfoUlezPage {...{ acf }} />
      <div ref={$content} data-testid="sticky-wrapper">
        {ready ? <StickyVRMUlez $content={$content.current} /> : null}
        <Section { ...{ acf }} />
        <Map { ...{ expandedMap, setExpandedMap }} />
        <div className={cx({ [styles.hiddenVisibility]: expandedMap })}>
          <Charges { ...{ acf }} />
          <Scheme bodyText={acf?.section_three_body_area as string} title={acf?.section_three_title as string} />
          <UlezFAQ {...{ faq, title } as any} />
          <Content className={styles.similarArticlesWrapper}>
            <SimilarArticles acf={generateSimilarArticlesData(acf)} />
          </Content>
        </div>
      </div>
    </div>
  );
};

export default Home;
